/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { CompanySettings } from './CompanySettings';
import {
  CompanySettingsFromJSON,
  CompanySettingsFromJSONTyped,
  CompanySettingsToJSON,
} from './CompanySettings';

/**
 *
 * @export
 * @interface Company
 */
export interface Company {
  /**
   *
   * @type {number}
   * @memberof Company
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof Company
   */
  key?: string;
  /**
   *
   * @type {CompanySettings}
   * @memberof Company
   */
  settings?: CompanySettings;
}

/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): value is Company {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function CompanyFromJSON(json: any): Company {
  return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Company {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    key: json['key'] == null ? undefined : json['key'],
    settings:
      json['settings'] == null
        ? undefined
        : CompanySettingsFromJSON(json['settings']),
  };
}

export function CompanyToJSON(value?: Company | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    key: value['key'],
    settings: CompanySettingsToJSON(value['settings']),
  };
}
